import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormatLabel } from './format-label'
import { useFormDefaultValue, useFormRequired, useFormSetValue } from './hooks/input-hooks'

export const FormHiddenText = ({ name, value, required, defaultValue, shouldDirty }) => {
  const { register } = useFormContext()

  const strValue = useMemo(() => value?.toString(), [value])

  useFormRequired(name, required)
  useFormDefaultValue(name, defaultValue, shouldDirty)
  useFormSetValue(name, strValue, shouldDirty)

  return (
    <FormatLabel>
      <input className="form-control" type="hidden" {...register(name, { required })} />
    </FormatLabel>
  )
}
